import ensureAjsAnonymousIdCookie
  from 'angieslist-app-platform/lib/common/analytics/ensureAjsAnonymousIdCookie';
import cookieUtils from 'angieslist-app-platform/lib/common/utils/cookieUtils';

export const PRO_ADS_LEADCALLTRACKING_V2_FRONTEND_LEAD_BOARD_FEATURE_FLAG = 'pro_ads_leadcalltracking_v2_frontend_lead_board';
export const PRO_LEADS_PRODUCTINFO_FRONTEND_BUSINESS_SELECT = 'pro_leads_productinfo_frontend_business_select';

export const getAnonymousId: () => string = (splitClientSideApiKey) => {
  let anonymousUserId = '';
  if (typeof window !== 'undefined' && splitClientSideApiKey) {
    ensureAjsAnonymousIdCookie();
    const ajsAnonymousId = cookieUtils.getCookie('ajs_anonymous_id');
    anonymousUserId = (ajsAnonymousId === undefined ? '' : ajsAnonymousId);
  }
  return anonymousUserId;
};

export const splitSdkConfig = splitClientSideApiKey => ({
  core: {
    authorizationKey: splitClientSideApiKey,
    key: getAnonymousId(splitClientSideApiKey),
  },
});

export const splitSdkConfigForSpId = (splitClientSideApiKey, spId) => ({
  core: {
    authorizationKey: splitClientSideApiKey,
    key: spId,
  },
});



// WEBPACK FOOTER //
// ./src/modules/common/splitSdkConfigSetup.js